import { useTranslate } from "@growtherapy/i18n";
import { Icon, Tag, Text } from "@growtherapy/sprout-ui";
import { faLightbulb } from "@fortawesome/pro-solid-svg-icons";
import { Toast, ToastRenderFnProps } from "../../toasts";

export function LeaveSessionNudgeToast({
  contentProps,
  descriptionProps,
  titleProps,
  ...toastAriaProps
}: ToastRenderFnProps) {
  const t = useTranslate();

  return (
    <Toast alignment="top" className="sm:w-[30rem]" {...toastAriaProps}>
      <div className="flex gap-4 align-start flex-col" {...contentProps}>
        <div className="flex justify-between">
          <Tag
            aria-label={t(
              "telehealth-core:controls.theCurrentAppointmentWillBeEndingSoon",
            )}
            use="green"
            className="flex flex-row justify-start items-center gap-2 px-2 py-1"
          >
            <Icon
              aria-hidden
              icon={faLightbulb}
              className="text-neutral-800 font-medium"
            />
            <Text
              variant="xs"
              className="text-neutral-800 font-medium"
              {...titleProps}
            >
              {t("telehealth-core:controls.growTip")}
            </Text>
          </Tag>
        </div>
        <Text variant="sm" {...descriptionProps}>
          {t("telehealth-core:controls.nearingTheEndUseTheLeaveSessionButton")}
        </Text>
      </div>
    </Toast>
  );
}
